import React from "react";
import cx from "classnames";
import { useField } from "formik";

import InputField from "./InputField";

const Dropdown = ({ className, containerClass, options, ...props }) => {
  const [field, meta] = useField(props);

  return (
    <InputField className={containerClass} {...{ ...props, meta }}>
      <select
        className={cx(
          "form-control gkit-select-md",
          className,
          meta && meta.touched && meta.error && "is-invalid"
        )}
        {...field}
        {...props}
      >
        {(options || []).map((option, idx) => {
          const sourceObj =
            typeof option === "string"
              ? { label: option, value: option }
              : option;
          return (
            <option key={idx} value={sourceObj.value}>
              {sourceObj.label}
            </option>
          );
        })}
      </select>
    </InputField>
  );
};

export default Dropdown;
